import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '../Dashboard/Sidebar';
import { Topbar } from '../Dashboard/Topbar';
import SessionLockModal from '../SessionLock/SessionLockModal';
import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import api from '../../services/api';

export default function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const location = useLocation();
  const lastTrackedRef = useRef('');

  useEffect(() => {
    if (isDesktop) {
      setMobileSidebarOpen(false);
    }
  }, [isDesktop]);

  useEffect(() => {
    const pathname = String(location?.pathname || '').trim();
    if (!pathname) return;
    const key = pathname;
    if (lastTrackedRef.current === key) return;
    lastTrackedRef.current = key;
    api.post('/registro-attivita/apertura-pagina', { percorso: pathname }).catch(() => {});
  }, [location?.pathname]);

  return (
    <div className="flex h-[100dvh] min-h-screen w-full overflow-hidden bg-background text-foreground font-sans antialiased">
      {isDesktop ? (
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      ) : (
        <Drawer
          anchor="left"
          open={mobileSidebarOpen}
          onClose={() => setMobileSidebarOpen(false)}
          ModalProps={{ keepMounted: true }}
        >
          <Box sx={{ width: 'min(85vw, 320px)', height: '100%' }}>
            <Sidebar collapsed={false} setCollapsed={() => {}} />
          </Box>
        </Drawer>
      )}
      <div className="flex-1 flex h-full flex-col min-w-0 max-w-full overflow-hidden transition-all duration-300">
        <Topbar
          onMenuClick={() => {
            if (isDesktop) {
              setCollapsed(!collapsed);
            } else {
              setMobileSidebarOpen(true);
            }
          }}
        />
        <SessionLockModal />
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-6 bg-muted/20">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
